import { themeObj } from '../types';
import paletteDark from './PaletteDark';
import paletteLight from './PaletteLight';

export default function getTheme(theme: string): themeObj {
  return theme === 'dark' ? paletteDark : paletteLight;
}
